//
// Copyright 2022 DXOS.org
//

// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=js"
// @generated from file dxos/edge/messenger.proto (package dxos.edge.messenger, syntax proto3)
/* eslint-disable */

//
// The messenger protocol supports routing messages between peers.
//

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Any } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_any } from "@bufbuild/protobuf/wkt";
import type { Message as Message$1 } from "@bufbuild/protobuf";

/**
 * Describes the file dxos/edge/messenger.proto.
 */
export const file_dxos_edge_messenger: GenFile = /*@__PURE__*/
  fileDesc("ChlkeG9zL2VkZ2UvbWVzc2VuZ2VyLnByb3RvEhNkeG9zLmVkZ2UubWVzc2VuZ2VyIuQCCgRQZWVyEhYKCXN3YXJtX2tleRgBIAEoCUgAiAEBEh0KDGlkZW50aXR5X2tleRgCIAEoCUICGAFIAYgBARIQCghwZWVyX2tleRgDIAEoCRJDChBjb25uZWN0aW9uX3N0YXRlGAUgASgOMiQuZHhvcy5lZGdlLm1lc3Nlbmdlci5Db25uZWN0aW9uU3RhdGVIAogBARIWCgljb25uZWN0ZWQYBiABKAFIA4gBARIZCgxkaXNjb25uZWN0ZWQYByABKAFIBIgBARIZCgxpZGVudGl0eV9kaWQYCCABKAlIBYgBARISCgVzdGF0ZRgEIAEoDEgGiAEBQgwKCl9zd2FybV9rZXlCDwoNX2lkZW50aXR5X2tleUITChFfY29ubmVjdGlvbl9zdGF0ZUIMCgpfY29ubmVjdGVkQg8KDV9kaXNjb25uZWN0ZWRCDwoNX2lkZW50aXR5X2RpZEIICgZfc3RhdGUixgIKB01lc3NhZ2USFgoJdGltZXN0YW1wGAEgASgJSACIAQESLgoGc291cmNlGAogASgLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVySAGIAQESKQoGdGFyZ2V0GAsgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyEhcKCnNlcnZpY2VfaWQYFCABKAlIAogBARI9Cg10cmFjZV9jb250ZXh0GBUgASgLMiEuZHhvcy5lZGdlLm1lc3Nlbmdlci5UcmFjZUNvbnRleHRIA4gBARIqCgdwYXlsb2FkGGQgASgLMhQuZ29vZ2xlLnByb3RvYnVmLkFueUgEiAEBQgwKCl90aW1lc3RhbXBCCQoHX3NvdXJjZUINCgtfc2VydmljZV9pZEIQCg5fdHJhY2VfY29udGV4dEIKCghfcGF5bG9hZCJLCgxUcmFjZUNvbnRleHQSEwoLdHJhY2VwYXJlbnQYASABKAkSFwoKdHJhY2VzdGF0ZRgCIAEoCUgAiAEBQg0KC190cmFjZXN0YXRlIpQBCgxTd2FybVJlcXVlc3QSPQoGYWN0aW9uGAEgASgOMiguZHhvcy5lZGdlLm1lc3Nlbmdlci5Td2FybVJlcXVlc3QuQWN0aW9uSACIAQESEQoJc3dhcm1LZXlzGAIgAygJIicKBkFjdGlvbhIICgRJTkZPEAASCAoESk9JThABEgkKBUxFQVZFEAJCCQoHX2FjdGlvbiJ+Cg1Td2FybVJlc3BvbnNlEhAKCHN3YXJtS2V5GAEgASgJEigKBXBlZXJzGAIgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyEjEKDmluYWN0aXZlX3BlZXJzGAMgAygLMhkuZHhvcy5lZGdlLm1lc3Nlbmdlci5QZWVyIi8KC1RleHRNZXNzYWdlEhQKB21lc3NhZ2UYASABKAlIAIgBAUIKCghfbWVzc2FnZSpSCg9Db25uZWN0aW9uU3RhdGUSDQoJQ09OTkVDVEVEEAASFwoTRElTQ09OTkVDVEVEX05PUk1BTBABEhcKE0RJU0NPTk5FQ1RFRF9BQlJVUFQQAmIGcHJvdG8z", [file_google_protobuf_any]);

/**
 *
 * Network peer.
 *
 * TODO(burdon): Distinguish between point-to-point and broadcast messaging.
 * TODO(burdon): Rename PeerInfo?
 * TODO(mykola): Separate peer info and peer state into different messages.
 *
 * @generated from message dxos.edge.messenger.Peer
 */
export type Peer = Message$1<"dxos.edge.messenger.Peer"> & {
  /**
   * TODO(burdon): Rename topic?
   *
   * @generated from field: optional string swarm_key = 1;
   */
  swarmKey?: string;

  /**
   * TODO(DX-1059): Remove once no pre-DID senders remain (phase 8, gated on telemetry).
   * @deprecated Hex identity key; use `identity_did` (field 8). Senders no longer write this; readers
   * still fall back to it for pre-DX-1059 peers. Retained for binary compatibility.
   *
   * @generated from field: optional string identity_key = 2 [deprecated = true];
   * @deprecated
   */
  identityKey?: string;

  /**
   * @generated from field: string peer_key = 3;
   */
  peerKey: string;

  /**
   * *
   * State of the connection to the swarm.
   *
   * *
   * UNIX timestamp of the connection.
   * @example 1715142000000
   *
   * @generated from field: optional dxos.edge.messenger.ConnectionState connection_state = 5;
   */
  connectionState?: ConnectionState;

  /**
   * Note: it is not `int64` because `int64` is compiled as a `string` in 'buf' and as a `number` in 'proto-js'.
   *
   * @generated from field: optional double connected = 6;
   */
  connected?: number;

  /**
   * *
   * UNIX timestamp of the disconnection.
   * @example 1715142000000
   *
   * @generated from field: optional double disconnected = 7;
   */
  disconnected?: number;

  /**
   * *
   * Owner identity DID (`did:halo:…`) — the peer's identity for point-to-point routing (DX-1059).
   * Supersedes the deprecated hex `identity_key` (field 2); it is the only identity field senders write.
   *
   * @generated from field: optional string identity_did = 8;
   */
  identityDid?: string;

  /**
   * *
   * Optional opeage data that represents peer state is updated on `join` request and all peers in swarm are notified.
   * Is not used for WebRTC protocol, but is useful for another purposes of Swarms, e. g. call room users states.
   *
   * @generated from field: optional bytes state = 4;
   */
  state?: Uint8Array;
};

/**
 * Describes the message dxos.edge.messenger.Peer.
 * Use `create(PeerSchema)` to create a new message.
 */
export const PeerSchema: GenMessage<Peer> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 0);

/**
 *
 * Message envelope.
 *
 *
 * @generated from message dxos.edge.messenger.Message
 */
export type Message = Message$1<"dxos.edge.messenger.Message"> & {
  /**
   * @generated from field: optional string timestamp = 1;
   */
  timestamp?: string;

  /**
   * Routing.
   *
   * @generated from field: optional dxos.edge.messenger.Peer source = 10;
   */
  source?: Peer;

  /**
   * @generated from field: repeated dxos.edge.messenger.Peer target = 11;
   */
  target: Peer[];

  /**
   * / List of valid services is defined in the `EdgeService` enum. 
   * / Maybe be used to address a service at EDGE, but also to address components inside the client.
   *
   * @generated from field: optional string service_id = 20;
   */
  serviceId?: string;

  /**
   * @generated from field: optional dxos.edge.messenger.TraceContext trace_context = 21;
   */
  traceContext?: TraceContext;

  /**
   * @generated from field: optional google.protobuf.Any payload = 100;
   */
  payload?: Any;
};

/**
 * Describes the message dxos.edge.messenger.Message.
 * Use `create(MessageSchema)` to create a new message.
 */
export const MessageSchema: GenMessage<Message> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 1);

/**
 * / W3C Trace Context propagation (https://www.w3.org/TR/trace-context/).
 *
 * @generated from message dxos.edge.messenger.TraceContext
 */
export type TraceContext = Message$1<"dxos.edge.messenger.TraceContext"> & {
  /**
   * / W3C `traceparent` header value (e.g. "00-<trace-id>-<parent-id>-<trace-flags>").
   *
   * @generated from field: string traceparent = 1;
   */
  traceparent: string;

  /**
   * / W3C `tracestate` header value; vendor-specific key-value pairs.
   *
   * @generated from field: optional string tracestate = 2;
   */
  tracestate?: string;
};

/**
 * Describes the message dxos.edge.messenger.TraceContext.
 * Use `create(TraceContextSchema)` to create a new message.
 */
export const TraceContextSchema: GenMessage<TraceContext> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 2);

/**
 *
 * Swarms are used to publish and subscribe to messages based on a topic.
 *
 *
 * @generated from message dxos.edge.messenger.SwarmRequest
 */
export type SwarmRequest = Message$1<"dxos.edge.messenger.SwarmRequest"> & {
  /**
   * @generated from field: optional dxos.edge.messenger.SwarmRequest.Action action = 1;
   */
  action?: SwarmRequest_Action;

  /**
   * TODO(burdon): Rename topic?
   *
   * @generated from field: repeated string swarmKeys = 2;
   */
  swarmKeys: string[];
};

/**
 * Describes the message dxos.edge.messenger.SwarmRequest.
 * Use `create(SwarmRequestSchema)` to create a new message.
 */
export const SwarmRequestSchema: GenMessage<SwarmRequest> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 3);

/**
 * @generated from enum dxos.edge.messenger.SwarmRequest.Action
 */
export enum SwarmRequest_Action {
  /**
   * @generated from enum value: INFO = 0;
   */
  INFO = 0,

  /**
   * @generated from enum value: JOIN = 1;
   */
  JOIN = 1,

  /**
   * @generated from enum value: LEAVE = 2;
   */
  LEAVE = 2,
}

/**
 * Describes the enum dxos.edge.messenger.SwarmRequest.Action.
 */
export const SwarmRequest_ActionSchema: GenEnum<SwarmRequest_Action> = /*@__PURE__*/
  enumDesc(file_dxos_edge_messenger, 3, 0);

/**
 * @generated from message dxos.edge.messenger.SwarmResponse
 */
export type SwarmResponse = Message$1<"dxos.edge.messenger.SwarmResponse"> & {
  /**
   * @generated from field: string swarmKey = 1;
   */
  swarmKey: string;

  /**
   * *
   * The list of peers in the swarm.
   *
   * @generated from field: repeated dxos.edge.messenger.Peer peers = 2;
   */
  peers: Peer[];

  /**
   * *
   * The list of peers that recently left the swarm.
   *
   * @generated from field: repeated dxos.edge.messenger.Peer inactive_peers = 3;
   */
  inactivePeers: Peer[];
};

/**
 * Describes the message dxos.edge.messenger.SwarmResponse.
 * Use `create(SwarmResponseSchema)` to create a new message.
 */
export const SwarmResponseSchema: GenMessage<SwarmResponse> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 4);

/**
 *
 * Text message.
 *
 *
 * @generated from message dxos.edge.messenger.TextMessage
 */
export type TextMessage = Message$1<"dxos.edge.messenger.TextMessage"> & {
  /**
   * @generated from field: optional string message = 1;
   */
  message?: string;
};

/**
 * Describes the message dxos.edge.messenger.TextMessage.
 * Use `create(TextMessageSchema)` to create a new message.
 */
export const TextMessageSchema: GenMessage<TextMessage> = /*@__PURE__*/
  messageDesc(file_dxos_edge_messenger, 5);

/**
 * @generated from enum dxos.edge.messenger.ConnectionState
 */
export enum ConnectionState {
  /**
   * @generated from enum value: CONNECTED = 0;
   */
  CONNECTED = 0,

  /**
   * @generated from enum value: DISCONNECTED_NORMAL = 1;
   */
  DISCONNECTED_NORMAL = 1,

  /**
   * @generated from enum value: DISCONNECTED_ABRUPT = 2;
   */
  DISCONNECTED_ABRUPT = 2,
}

/**
 * Describes the enum dxos.edge.messenger.ConnectionState.
 */
export const ConnectionStateSchema: GenEnum<ConnectionState> = /*@__PURE__*/
  enumDesc(file_dxos_edge_messenger, 0);

